import { render, staticRenderFns } from "./phone-form.vue?vue&type=template&id=5c08415e&lang=pug&"
import script from "./phone-form.vue?vue&type=script&lang=js&"
export * from "./phone-form.vue?vue&type=script&lang=js&"
import style0 from "./phone-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports